import axios from "axios";
import { getAnalyticsHeaders } from "@/lib/analytics";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("en_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  Object.assign(config.headers, getAnalyticsHeaders());
  return config;
});

export default api;

export function formatDkk(v) {
  if (v == null) return "";
  return `${Number(v).toLocaleString("da-DK")} kr`;
}

export function formatApiError(detail) {
  if (!detail) return "Noget gik galt. Prøv igen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
